import { createAction } from "redux-actions";
import { ACTIVE_MENU_ITEM, API } from "../constants/actionTypes";
import { apiPayloadCreator } from "../utils/appUtils";

export const activeMenuItem = createAction(ACTIVE_MENU_ITEM);
//TODO NANG CAP DOAN API CREATION BANG COMMON GOI PUT POST TRUYEN PARAM